import axiosInstance from "../utils/axios";
import { URL } from "../utils/axios";

const API_URL = `${URL}/api/blogs`;
const CATEGORIES_URL = `${API_URL}/categories`;
const LABELS_URL = `${API_URL}/labels`;

// Fetch all properties
export const fetchBlogs = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addBlog = async (blogData) => {
  try {
    const response = await axiosInstance.post(API_URL, blogData);
    return response.data;
  } catch (error) {
    throw error;
  }
}
export const updateBlog = async (id, blogData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${id}`, blogData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const deleteBlog = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fetch all categories
export const fetchCategories = async () => {
  try {
    const response = await axiosInstance.get(CATEGORIES_URL);
    return response.data;
  } catch (error) {
    throw error;
  }
}


// Fetch all labels
export const fetchLabels = async () => {
  try {
    const response = await axiosInstance.get(LABELS_URL);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Add a new category
export const addCategory = async (categoryData) => {
  try {
    const response = await axiosInstance.post(CATEGORIES_URL, categoryData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Update an existing category
export const updateCategory = async (id, categoryData) => {
  try {
    const response = await axiosInstance.put(`${CATEGORIES_URL}/${id}`, categoryData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete a category
export const deleteCategory = async (id) => {
  try {
    const response = await axiosInstance.delete(`${CATEGORIES_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Add a new label
export const addLabel = async (labelData) => {
  try {
    const response = await axiosInstance.post(LABELS_URL, labelData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Update an existing label
export const updateLabel = async (id, labelData) => {
  try {
    const response = await axiosInstance.put(`${LABELS_URL}/${id}`, labelData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Delete a label
export const deleteLabel = async (id) => {
  try {
    const response = await axiosInstance.delete(`${LABELS_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}